import React, { PropTypes } from 'react';
import classNames from 'classnames';

const UploadMask = (props) => {

    const styleClasses = classNames({
        "MU_progress": true,
        "no-photo": props.path === null && props.reference === null,
    });

    const progressBarClasses = classNames({
        "MU_progress_bar": true,
        "uploading": props.percent < 100
    });


    return(
        <div className={styleClasses}>
            <div className="MU_progress_text">Upload...</div>
            <div className="MU_progress_bar--wrapper">
                <div className="MU_progress_bar--background"></div>
                <div className={progressBarClasses} style={{width: `${props.percent}%`}}></div>
            </div>
        </div>
    )
};

UploadMask.propTypes = {
    percent: PropTypes.number
};

export default UploadMask;



// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/MediaUploaderSmall/UploadMask.jsx